export const useAppUserDataStore = () => {
  const user = useCurrentUser();

  return useAppUserData(user.value?.uid ?? "")();
};
